import { render } from "./PaymentFailureModal.vue?vue&type=template&id=479435ea&scoped=true"
import script from "./PaymentFailureModal.vue?vue&type=script&lang=js"
export * from "./PaymentFailureModal.vue?vue&type=script&lang=js"

import "./PaymentFailureModal.vue?vue&type=style&index=0&id=479435ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479435ea"]])

export default __exports__